export const SET_USER = "SET_USER";
export const POST_VALIDATE_SSO_TOKEN_REQUEST = "POST_VALIDATE_SSO_TOKEN_REQUEST";
export const POST_VALIDATE_SSO_TOKEN_RESPONSE = "POST_VALIDATE_SSO_TOKEN_RESPONSE";
